<a [routerLink]="['/product-catalog/detail', product.product.id, product.product.category]">
      <img [src]="product.product.image" alt="" style="max-width: 100%; max-height: 20rem;">
</a>


